<template lang="pug">
p.mt-3.rounded-lg.border.border-red-200.bg-red-50.p-3.text-sm.font-medium.text-red-700(
	v-if="message"
	role="alert"
) {{ message }}
</template>

<script>
export default {
	props: {
		message: { type: String, default: "" }
	}
}
</script>
